import Meta from '@/components/common/Meta'

import SelfStorageSolutionPage from '@/v2/components/pages/landing-pages/self-storage-solution-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/self-storage-solution-page'

interface SelfStorageSolutionPageProps {}

const Page: React.FC<SelfStorageSolutionPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.self_storage_solution.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.self_storage_solution?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.self_storage_solution?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <SelfStorageSolutionPage />
    </>
  )
}

export default Page
